import { useTranslation } from 'react-i18next';

import './RequestStatusPill.css';

// UI status labels — DB enum `request_status` is lower_snake_case (`treated`
// etc.); the dashboard surfaces UPPER labels with `PROCESSED` replacing
// `treated`. Mapping DB → UI lives in `src/lib/db/buyer/requests.ts`
// (STATUS_DB_TO_UI).
export type RequestStatusUi = 'NEW' | 'IN_PROGRESS' | 'PROCESSED' | 'CLOSED';

export type RequestStatusPillProps = {
  status: RequestStatusUi;
};

const STATUS_KEY: Record<RequestStatusUi, string> = {
  NEW: 'common:buyer.requests.status.NEW',
  IN_PROGRESS: 'common:buyer.requests.status.IN_PROGRESS',
  PROCESSED: 'common:buyer.requests.status.PROCESSED',
  CLOSED: 'common:buyer.requests.status.CLOSED',
};

const STATUS_CLASS: Record<RequestStatusUi, string> = {
  NEW: 'request-pill--new',
  IN_PROGRESS: 'request-pill--in-progress',
  PROCESSED: 'request-pill--processed',
  CLOSED: 'request-pill--closed',
};

export function RequestStatusPill({ status }: RequestStatusPillProps) {
  const { t } = useTranslation();
  return <span className={`request-pill ${STATUS_CLASS[status]}`}>{t(STATUS_KEY[status])}</span>;
}
